<template lang="pug">
    //- Cclone positive
    .cell-content-wrapper.l-flex-column.cclone-volume(v-if="type === 'positive_events'")
        .positive-type.css-cut-long-text {{ fullData.positive_events }}
        .l-flex-row
            .positive-volume.l-flex-row {{ formatVolume(fullData.positive_volume) }}

    //- Cclone universe
    .cell-content-wrapper.l-flex-column.cclone-volume(v-else-if="type === 'negative_events'")
        .negative-type.css-cut-long-text {{ fullData.negative_events }}
        .l-flex-row
            .negative-volume {{ formatVolume(fullData.negative_volume) }}


</template>

<script>
import { formatNumber } from '@/utils/helpers'

export default {
    props: {
        data: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
        fullData: {
            type: Object,
            default: () => ({})
        }
    },

    methods: {
        formatVolume(volume) {
            return volume !== 'N/A' ? formatNumber(volume) : 'N/A'
        }
    }
}
</script>
